import debounce from 'lodash/debounce'
import { PAGE_SIZE } from './funding'

export default {
  data() {
    return {
      items: [],
      search: '',
      page: 1,
      count: 0,
      loading: false,
      loaded: false,
      failed: false,
      requestId: 0,
      searchLater: null,
    }
  },
  created() {
    this.searchLater = debounce(this.fetchItems, 350)
    this.fetchItems()
  },
  beforeDestroy() {
    this.searchLater.cancel()
    this.requestId++
  },
  methods: {
    async fetchItems() {
      const requestId = ++this.requestId
      this.loading = true
      this.failed = false
      try {
        const { data } = await this.requestItems({
          search: this.search || undefined,
          page: this.page,
          page_size: PAGE_SIZE,
        })
        if (requestId !== this.requestId) return
        this.items = data.results
        this.count = data.count
        this.loaded = true
        if (this.onItemsLoaded) this.onItemsLoaded()
      } catch (error) {
        if (requestId === this.requestId) this.failed = true
      } finally {
        if (requestId === this.requestId) this.loading = false
      }
    },
    onSearch() {
      this.page = 1
      this.requestId++
      this.loading = true
      this.searchLater()
    },
    changePage(page) {
      this.searchLater.cancel()
      this.page = page
      this.fetchItems()
    },
  },
}
